import React, {useEffect} from "preact/compat";
import {useState} from 'preact/hooks';
import {PriceAndSize} from "../typings/types";
import {getFromJson} from "../canvas/menu-object-renderer";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import {getEmptyPrice} from "../util";
import { removeTrailingZeroes } from "../canvas/menu-object";

export interface MenuContentPrices {
  menuPrices: string[] | PriceAndSize[],
  onUpdate: (type: string, value: string, idx: number) => void,
  onRemove: (type: string, idx: number) => void,
  menuObjectLayout: string,
  hideTrailingZeroes: boolean,
}

const MAX_PRICES = 6;

export default function MenuContentPrices({ menuPrices, onUpdate, onRemove, menuObjectLayout, hideTrailingZeroes }: MenuContentPrices) {
  const [prices, setPrices] = useState([] as PriceAndSize[]);

  useEffect(() => {
    let pr = !menuPrices ? [] : menuPrices
      //@ts-ignore
      .filter((it: string | PriceAndSize) => typeof it === 'object' || (it && it.trim().length))
      .map((it: string | PriceAndSize) => getFromJson(it) as PriceAndSize);
    if (!pr.length) {
      pr = [getEmptyPrice()]
    }

    setPrices(pr);
  }, [menuPrices]);

  function setPriceAtIdx(newPrice: PriceAndSize, idx: number) {
    setPrices([
      ...prices.slice(0, idx),
      newPrice,
      ...prices.slice(idx + 1)
    ]);
  }

  function onChange(type: keyof PriceAndSize, value: string, idx: number) {
    const newPrice = {
      ...prices[idx],
      [type as keyof PriceAndSize]: value.replace(/"/g, "&dqt"),
      displayPrice: type === 'price' ?
                      hideTrailingZeroes ? removeTrailingZeroes(value.replace(/"/g, "&dqt")) : value.replace(/"/g, "&dqt")
                    : hideTrailingZeroes ? removeTrailingZeroes(prices[idx].price) : prices[idx].price
    };

    setPriceAtIdx(newPrice, idx);

    onUpdate('prices', JSON.stringify(newPrice), idx);
  }

  function onRemovePrice(idx: number) {
    const newPrices = prices.filter((v, i) => idx !== i);
    if (newPrices.length === 1) {
      newPrices[0].size = "";
    }
    setPrices(newPrices);
    onRemove('prices', idx);
  }

  function onAddEntry() {
    setPrices([...prices, getEmptyPrice()]);
  }

  return (
    <div className="prices">
      {prices.map((price, idx) =>
        <div className={`price ${prices.length === 1 ? 'one-price' : ''}`}>
          {prices.length > 1 && <input tabIndex={4 + idx} placeholder={`Size ${idx + 1}`} className="field size"
                                       spellcheck
                                       autoComplete={'off'}
                                       value={price.size.replace(/&dqt/g, '"')}
                                       onChange={e => onChange('size', (e.target as HTMLInputElement)?.value, idx)}/>}

          <input tabIndex={3 + idx} placeholder={`Price ${prices.length > 1 ? idx + 1 : ''}`} className="field price" spellcheck
                 autoComplete="off"
                 value={price.price.replace(/&dqt/g, '"')}
                 onChange={e => onChange('price', (e.target as HTMLInputElement)?.value, idx)}/>

          {prices.length === 1 && <button className={'add-size'} onClick={onAddEntry}><span>+ Price</span></button>}

          {prices.length > 1 && <button><DeleteOutlined onClick={() => onRemovePrice(idx)}/></button>}
        </div>
      )}
      {prices.length >= 2 && prices.length < MAX_PRICES && <button className={'add-size'} onClick={onAddEntry}><span>+ Price</span></button>}
    </div>
  )
}
